var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreetext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 6,
    viewBox: "0 0 15 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.5C0.5375 5.5 0.359417 5.42808 0.21575 5.28425C0.0719168 5.14042 0 4.96225 0 4.74975C0 4.53708 0.0719168 4.359 0.21575 4.2155C0.359417 4.07183 0.5375 4 0.75 4H8.25C8.4625 4 8.64058 4.07192 8.78425 4.21575C8.92808 4.35958 9 4.53775 9 4.75025C9 4.96292 8.92808 5.141 8.78425 5.2845C8.64058 5.42817 8.4625 5.5 8.25 5.5H0.75ZM0.75 1.5C0.5375 1.5 0.359417 1.42808 0.21575 1.28425C0.0719168 1.14042 0 0.96225 0 0.74975C0 0.537083 0.0719168 0.359 0.21575 0.2155C0.359417 0.0718332 0.5375 0 0.75 0H14.25C14.4625 0 14.6406 0.0719168 14.7843 0.21575C14.9281 0.359583 15 0.53775 15 0.75025C15 0.962917 14.9281 1.141 14.7843 1.2845C14.6406 1.42817 14.4625 1.5 14.25 1.5H0.75Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreetext);
export default __webpack_public_path__ + "static/media/freetext.c7f8a0c5228c3ce551519f29e103342c.svg";
export { ForwardRef as ReactComponent };